// icons.ts
import { FileText, Home, User, Settings, Search, Handshake, BookUser, CircleHelp, ChevronLeft, CircleAlert, Plus, X, ArrowLeft, ChevronRight, Pencil, Trash2, FileUser, SearchIcon, Check, Calendar, Mail, Navigation, Minus, Eye, Fullscreen, CornerDownRight, ArrowUpDown, Trash, CloudUpload, File, Paperclip, Eraser, Download, Lightbulb, ChevronUp, ChevronDown, FileX } from 'lucide-angular';

export const Icons = {
    FileText,
    Home,
    User,
    Settings,
    Search,
    Handshake,
    BookUser,
    CircleHelp,
    ChevronUp,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    CircleAlert,
    Plus,
    X,
    ArrowLeft,
    Pencil,
    Trash2,
    FileUser,
    SearchIcon,
    Check,
    Calendar,
    Mail,
    Navigation,
    Minus,
    Eye,
    Fullscreen,
    CornerDownRight,
    ArrowUpDown,
    Trash,
    CloudUpload,
    File,
    FileX,
    Paperclip,
    Eraser, 
    Download,
    Lightbulb
} as const;